import React from 'react';
import { useI18n, LANG_KEYS, LANG_NAMES } from '../i18n';

export default function LanguageSwitcher({ phase }) {
  const { lang, setLang } = useI18n();
  const className =
    'lang-switch' + (phase === 'play' ? ' lang-switch--playing' : '');
  return (
    <div className={className} role="group" aria-label="Language">
      {LANG_KEYS.map((l) => (
        <button
          key={l}
          type="button"
          className={'lang-switch__btn' + (l === lang ? ' is-active' : '')}
          aria-current={l === lang}
          onClick={() => setLang(l)}
        >
          {LANG_NAMES[l]}
        </button>
      ))}
    </div>
  );
}
